import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import YourAvatarHolder from '../organisms/YourAvatarHolder';
import LoadingScreen from '../organisms/LoadingScreen';
import AlertMessage from '../molecules/AlertMessage';
import Collection from '../organisms/Collection';

class YourAvatar extends Component {

  state = {
    redirect: false,
  };

  nextHandler = () => {
    this.setState({
      redirect: '/learning-outcomes',
    })
  };

  render() {
    const { avatar, participant } = this.props;

    if ( this.state.redirect ) {
      return <Redirect push to={ this.state.redirect } />;
    } else {
      return (
        <main>
          <LoadingScreen/>
          <AlertMessage>
            <p className="h1">Pause!</p>
            <p><strong className="highlight-yellow">Pause here to
              { participant.workshop ? " share your avatar with your workshop partner and discuss" : " compare your avatar with others from around the world" }
              .</strong></p>
            <p>Was there anything missing while labeling this avatar?</p>
          </AlertMessage>
          <h1>Your Avatar</h1>
          <YourAvatarHolder
            currentAvatar={avatar.currentAvatar}
            features={avatar[avatar.currentAvatar]}/>
          <h3 className="regular"><strong className="highlight-yellow">Compare your avatar</strong> with others from
            { participant.workshop ? " your workshop" : " around the world" }.</h3>
          <Collection
            avatarPrefix={avatar.currentAvatar}
            participantlocation={participant.participantlocation}
            showInfo
            workshop={participant.workshop}/>
          <button className="primary" onClick={this.nextHandler}>Next</button>
        </main>
      )
    }
  }
}

function mapStateToProps( state ) {
  return {
    avatar: state.avatar,
    participant: state.participant,
  };
}

export default connect( mapStateToProps )( YourAvatar );
